import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import Status from "../status/Status";
import { initGtm } from "../gtm/GoogleTagManager";
var GTM = /*#__PURE__*/ function() {
    "use strict";
    function GTM(id, auth, preview, cookies_win, dataLayerName, dataLayer, event) {
        _class_call_check(this, GTM);
        this.isActive = true;
        this._id = id;
        this._auth = auth;
        this._preview = preview;
        this._cookies_win = cookies_win;
        this._dataLayerName = dataLayerName;
        this._dataLayer = dataLayer;
        this._events = event;
    }
    var _proto = GTM.prototype;
    _proto.init = function init() {
        initGtm({
            id: this._id
        });
        return new Status(this, true);
    };
    _proto.sendEvent = function sendEvent(data) {
        var _this = this;
        return new Promise(function(resolve) {
            window[_this._dataLayerName].push(Object.assign({
                event: data.event,
                eventCallback: function() {
                    resolve(new Status(_this, true));
                },
                eventTimeout: 2000
            }, data.property));
        });
    };
    _create_class(GTM, [
        {
            key: "id",
            get: function get() {
                return this._id;
            },
            set: function set(value) {
                this._id = value;
            }
        },
        {
            key: "auth",
            get: function get() {
                return this._auth;
            },
            set: function set(value) {
                this._auth = value;
            }
        },
        {
            key: "preview",
            get: function get() {
                return this._preview;
            },
            set: function set(value) {
                this._preview = value;
            }
        },
        {
            key: "cookies_win",
            get: function get() {
                return this._cookies_win;
            },
            set: function set(value) {
                this._cookies_win = value;
            }
        },
        {
            key: "dataLayerName",
            get: function get() {
                return this._dataLayerName;
            },
            set: function set(value) {
                this._dataLayerName = value;
            }
        },
        {
            key: "dataLayer",
            get: function get() {
                return this._dataLayer;
            },
            set: function set(value) {
                this._dataLayer = value;
            }
        },
        {
            key: "events",
            get: function get() {
                return this._events;
            },
            set: function set(value) {
                this._events = value;
            }
        }
    ]);
    return GTM;
}();
export { GTM as default };
